export default __webpack_public_path__ + "static/media/processed.403ba425.png";